export default "__VITE_ASSET__638e2447__"